import { getCurrentLanguage as le } from "@gitcoffee/i18n";
import { storage as C } from "@gitcoffee/storage";
// @__NO_SIDE_EFFECTS__
function ce(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const gt = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Ft = () => {
}, ue = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), j = Object.assign, fe = Object.prototype.hasOwnProperty, dt = (e, t) => fe.call(e, t), m = Array.isArray, W = (e) => Tt(e) === "[object Map]", F = (e) => typeof e == "function", D = (e) => typeof e == "string", q = (e) => typeof e == "symbol", P = (e) => e !== null && typeof e == "object", ge = Object.prototype.toString, Tt = (e) => ge.call(e), Mt = (e) => Tt(e).slice(8, -1), yt = (e) => D(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, de = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return ((n) => t[n] || (t[n] = e(n)));
}, pe = de((e) => e.charAt(0).toUpperCase() + e.slice(1)), wt = (e, t) => !Object.is(e, t);
let Ot;
const st = () => Ot || (Ot = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function _t(e) {
  if (m(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n], o = D(s) ? we(s) : _t(s);
      if (o)
        for (const i in o)
          t[i] = o[i];
    }
    return t;
  } else if (D(e) || P(e))
    return e;
}
const he = /;(?![^(]*\))/g, me = /:([^]+)/, ye = /\/\*[^]*?\*\//g;
function we(e) {
  const t = {};
  return e.replace(ye, "").split(he).forEach((n) => {
    if (n) {
      const s = n.split(me);
      s.length > 1 && (t[s[0].trim()] = s[1].trim());
    }
  }), t;
}
function Pt(e) {
  let t = "";
  if (D(e))
    t = e;
  else if (m(e))
    for (let n = 0; n < e.length; n++) {
      const s = Pt(e[n]);
      s && (t += s + " ");
    }
  else if (P(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
function K(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Lt = 0, it;
function St() {
  Lt++;
}
function vt() {
  if (--Lt > 0)
    return;
  let e;
  for (; it; ) {
    let t = it;
    for (it = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (s) {
          e || (e = s);
        }
      t = n;
    }
  }
  if (e) throw e;
}
class _e {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
  }
  trigger(t) {
    this.version++, this.notify(t);
  }
  notify(t) {
    St();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let n = this.subsHead; n; n = n.nextSub)
          n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
            j(
              {
                effect: n.sub
              },
              t
            )
          );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      vt();
    }
  }
}
const Pe = /* @__PURE__ */ new WeakMap(), rt = /* @__PURE__ */ Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), At = /* @__PURE__ */ Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), Nt = /* @__PURE__ */ Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function R(e, t, n, s, o, i) {
  const r = Pe.get(e);
  if (!r)
    return;
  const a = (l) => {
    l && (process.env.NODE_ENV !== "production" ? l.trigger({
      target: e,
      type: t,
      key: n,
      newValue: s,
      oldValue: o,
      oldTarget: i
    }) : l.trigger());
  };
  if (St(), t === "clear")
    r.forEach(a);
  else {
    const l = m(e), u = l && yt(n);
    if (l && n === "length") {
      const g = Number(s);
      r.forEach((c, f) => {
        (f === "length" || f === Nt || !q(f) && f >= g) && a(c);
      });
    } else
      switch ((n !== void 0 || r.has(void 0)) && a(r.get(n)), u && a(r.get(Nt)), t) {
        case "add":
          l ? u && a(r.get("length")) : (a(r.get(rt)), W(e) && a(r.get(At)));
          break;
        case "delete":
          l || (a(r.get(rt)), W(e) && a(r.get(At)));
          break;
        case "set":
          W(e) && a(r.get(rt));
          break;
      }
  }
  vt();
}
function T(e) {
  const t = d(e);
  return t === e || S(e) ? t : t.map(O);
}
function bt(e) {
  return e = d(e), e;
}
function A(e, t) {
  return b(e) ? $t(e) ? B(O(t)) : B(t) : O(t);
}
const Se = {
  __proto__: null,
  [Symbol.iterator]() {
    return at(this, Symbol.iterator, (e) => A(this, e));
  },
  concat(...e) {
    return T(this).concat(
      ...e.map((t) => m(t) ? T(t) : t)
    );
  },
  entries() {
    return at(this, "entries", (e) => (e[1] = A(this, e[1]), e));
  },
  every(e, t) {
    return E(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return E(
      this,
      "filter",
      e,
      t,
      (n) => n.map((s) => A(this, s)),
      arguments
    );
  },
  find(e, t) {
    return E(
      this,
      "find",
      e,
      t,
      (n) => A(this, n),
      arguments
    );
  },
  findIndex(e, t) {
    return E(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return E(
      this,
      "findLast",
      e,
      t,
      (n) => A(this, n),
      arguments
    );
  },
  findLastIndex(e, t) {
    return E(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return E(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return lt(this, "includes", e);
  },
  indexOf(...e) {
    return lt(this, "indexOf", e);
  },
  join(e) {
    return T(this).join(e);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...e) {
    return lt(this, "lastIndexOf", e);
  },
  map(e, t) {
    return E(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return I(this, "pop");
  },
  push(...e) {
    return I(this, "push", e);
  },
  reduce(e, ...t) {
    return Rt(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Rt(this, "reduceRight", e, t);
  },
  shift() {
    return I(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return E(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return I(this, "splice", e);
  },
  toReversed() {
    return T(this).toReversed();
  },
  toSorted(e) {
    return T(this).toSorted(e);
  },
  toSpliced(...e) {
    return T(this).toSpliced(...e);
  },
  unshift(...e) {
    return I(this, "unshift", e);
  },
  values() {
    return at(this, "values", (e) => A(this, e));
  }
};
function at(e, t, n) {
  const s = bt(e), o = s[t]();
  return s !== e && !S(e) && (o._next = o.next, o.next = () => {
    const i = o._next();
    return i.done || (i.value = n(i.value)), i;
  }), o;
}
const ve = Array.prototype;
function E(e, t, n, s, o, i) {
  const r = bt(e), a = r !== e && !S(e), l = r[t];
  if (l !== ve[t]) {
    const c = l.apply(e, i);
    return a ? O(c) : c;
  }
  let u = n;
  r !== e && (a ? u = function(c, f) {
    return n.call(this, A(e, c), f, e);
  } : n.length > 2 && (u = function(c, f) {
    return n.call(this, c, f, e);
  }));
  const g = l.call(r, u, s);
  return a && o ? o(g) : g;
}
function Rt(e, t, n, s) {
  const o = bt(e);
  let i = n;
  return o !== e && (S(e) ? n.length > 3 && (i = function(r, a, l) {
    return n.call(this, r, a, l, e);
  }) : i = function(r, a, l) {
    return n.call(this, r, A(e, a), l, e);
  }), o[t](i, ...s);
}
function lt(e, t, n) {
  const s = d(e), o = s[t](...n);
  return (o === -1 || o === !1) && Z(n[0]) ? (n[0] = d(n[0]), s[t](...n)) : o;
}
function I(e, t, n = []) {
  St();
  const s = d(e)[t].apply(e, n);
  return vt(), s;
}
const be = /* @__PURE__ */ ce("__proto__,__v_isRef,__isVue"), zt = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(q)
);
function Ee(e) {
  return q(e) || (e = String(e)), d(this).hasOwnProperty(e);
}
class Kt {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, s) {
    if (n === "__v_skip") return t.__v_skip;
    const o = this._isReadonly, i = this._isShallow;
    if (n === "__v_isReactive")
      return !o;
    if (n === "__v_isReadonly")
      return o;
    if (n === "__v_isShallow")
      return i;
    if (n === "__v_raw")
      return s === (o ? i ? Ve : Ht : i ? ke : jt).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(s) ? t : void 0;
    const r = m(t);
    if (!o) {
      let l;
      if (r && (l = Se[n]))
        return l;
      if (n === "hasOwnProperty")
        return Ee;
    }
    const a = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      x(t) ? t : s
    );
    if ((q(n) ? zt.has(n) : be(n)) || i)
      return a;
    if (x(a)) {
      const l = r && yt(n) ? a : a.value;
      return o && P(l) ? ht(l) : l;
    }
    return P(a) ? o ? ht(a) : Et(a) : a;
  }
}
class $e extends Kt {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, s, o) {
    let i = t[n];
    const r = m(t) && yt(n);
    if (!this._isShallow) {
      const u = b(i);
      if (!S(s) && !b(s) && (i = d(i), s = d(s)), !r && x(i) && !x(s))
        return u ? (process.env.NODE_ENV !== "production" && K(
          `Set operation on key "${String(n)}" failed: target is readonly.`,
          t[n]
        ), !0) : (i.value = s, !0);
    }
    const a = r ? Number(n) < t.length : dt(t, n), l = Reflect.set(
      t,
      n,
      s,
      x(t) ? t : o
    );
    return t === d(o) && (a ? wt(s, i) && R(t, "set", n, s, i) : R(t, "add", n, s)), l;
  }
  deleteProperty(t, n) {
    const s = dt(t, n), o = t[n], i = Reflect.deleteProperty(t, n);
    return i && s && R(t, "delete", n, void 0, o), i;
  }
  has(t, n) {
    const s = Reflect.has(t, n);
    return !q(n) || zt.has(n), s;
  }
  ownKeys(t) {
    return Reflect.ownKeys(t);
  }
}
class xe extends Kt {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && K(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && K(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const De = /* @__PURE__ */ new $e(), Oe = /* @__PURE__ */ new xe(), pt = (e) => e, J = (e) => Reflect.getPrototypeOf(e);
function Ae(e, t, n) {
  return function(...s) {
    const o = this.__v_raw, i = d(o), r = W(i), a = e === "entries" || e === Symbol.iterator && r, l = o[e](...s), u = n ? pt : t ? B : O;
    return {
      // iterator protocol
      next() {
        const { value: g, done: c } = l.next();
        return c ? { value: g, done: c } : {
          value: a ? [u(g[0]), u(g[1])] : u(g),
          done: c
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function G(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      K(
        `${pe(e)} operation ${n}failed: target is readonly.`,
        d(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function Ne(e, t) {
  const n = {
    get(o) {
      const i = this.__v_raw, r = d(i), a = d(o), { has: l } = J(r), u = t ? pt : e ? B : O;
      if (l.call(r, o))
        return u(i.get(o));
      if (l.call(r, a))
        return u(i.get(a));
      i !== r && i.get(o);
    },
    get size() {
      const o = this.__v_raw;
      return !e && (d(o), void 0), o.size;
    },
    has(o) {
      const i = this.__v_raw;
      d(i);
      const r = d(o);
      return o === r ? i.has(o) : i.has(o) || i.has(r);
    },
    forEach(o, i) {
      const r = this, a = r.__v_raw;
      d(a);
      const l = t ? pt : e ? B : O;
      return a.forEach((u, g) => o.call(i, l(u), l(g), r));
    }
  };
  return j(
    n,
    e ? {
      add: G("add"),
      set: G("set"),
      delete: G("delete"),
      clear: G("clear")
    } : {
      add(o) {
        !t && !S(o) && !b(o) && (o = d(o));
        const i = d(this);
        return J(i).has.call(i, o) || (i.add(o), R(i, "add", o, o)), this;
      },
      set(o, i) {
        !t && !S(i) && !b(i) && (i = d(i));
        const r = d(this), { has: a, get: l } = J(r);
        let u = a.call(r, o);
        u ? process.env.NODE_ENV !== "production" && Ct(r, a, o) : (o = d(o), u = a.call(r, o));
        const g = l.call(r, o);
        return r.set(o, i), u ? wt(i, g) && R(r, "set", o, i, g) : R(r, "add", o, i), this;
      },
      delete(o) {
        const i = d(this), { has: r, get: a } = J(i);
        let l = r.call(i, o);
        l ? process.env.NODE_ENV !== "production" && Ct(i, r, o) : (o = d(o), l = r.call(i, o));
        const u = a ? a.call(i, o) : void 0, g = i.delete(o);
        return l && R(i, "delete", o, void 0, u), g;
      },
      clear() {
        const o = d(this), i = o.size !== 0, r = process.env.NODE_ENV !== "production" ? W(o) ? new Map(o) : new Set(o) : void 0, a = o.clear();
        return i && R(
          o,
          "clear",
          void 0,
          void 0,
          r
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((o) => {
    n[o] = Ae(o, e, t);
  }), n;
}
function Ut(e, t) {
  const n = Ne(e, t);
  return (s, o, i) => o === "__v_isReactive" ? !e : o === "__v_isReadonly" ? e : o === "__v_raw" ? s : Reflect.get(
    dt(n, o) && o in s ? n : s,
    o,
    i
  );
}
const Re = {
  get: /* @__PURE__ */ Ut(!1, !1)
}, Ce = {
  get: /* @__PURE__ */ Ut(!0, !1)
};
function Ct(e, t, n) {
  const s = d(n);
  if (s !== n && t.call(e, s)) {
    const o = Mt(e);
    K(
      `Reactive ${o} contains both the raw and reactive versions of the same object${o === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const jt = /* @__PURE__ */ new WeakMap(), ke = /* @__PURE__ */ new WeakMap(), Ht = /* @__PURE__ */ new WeakMap(), Ve = /* @__PURE__ */ new WeakMap();
function Fe(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Te(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Fe(Mt(e));
}
function Et(e) {
  return b(e) ? e : It(
    e,
    !1,
    De,
    Re,
    jt
  );
}
function ht(e) {
  return It(
    e,
    !0,
    Oe,
    Ce,
    Ht
  );
}
function It(e, t, n, s, o) {
  if (!P(e))
    return process.env.NODE_ENV !== "production" && K(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = Te(e);
  if (i === 0)
    return e;
  const r = o.get(e);
  if (r)
    return r;
  const a = new Proxy(
    e,
    i === 2 ? s : n
  );
  return o.set(e, a), a;
}
function $t(e) {
  return b(e) ? $t(e.__v_raw) : !!(e && e.__v_isReactive);
}
function b(e) {
  return !!(e && e.__v_isReadonly);
}
function S(e) {
  return !!(e && e.__v_isShallow);
}
function Z(e) {
  return e ? !!e.__v_raw : !1;
}
function d(e) {
  const t = e && e.__v_raw;
  return t ? d(t) : e;
}
const O = (e) => P(e) ? Et(e) : e, B = (e) => P(e) ? ht(e) : e;
function x(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function Me(e) {
  return Le(e, !1);
}
function Le(e, t) {
  return x(e) ? e : new ze(e, t);
}
class ze {
  constructor(t, n) {
    this.dep = new _e(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : d(t), this._value = n ? t : O(t), this.__v_isShallow = n;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, s = this.__v_isShallow || S(t) || b(t);
    t = s ? t : d(t), wt(t, n) && (this._rawValue = t, this._value = s ? t : O(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: n
    }) : this.dep.trigger());
  }
}
const V = [];
function Ke(e) {
  V.push(e);
}
function Ue() {
  V.pop();
}
let ct = !1;
function U(e, ...t) {
  if (ct) return;
  ct = !0;
  const n = V.length ? V[V.length - 1].component : null, s = n && n.appContext.config.warnHandler, o = je();
  if (s)
    xt(
      s,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((i) => {
          var r, a;
          return (a = (r = i.toString) == null ? void 0 : r.call(i)) != null ? a : JSON.stringify(i);
        }).join(""),
        n && n.proxy,
        o.map(
          ({ vnode: i }) => `at <${ie(n, i.type)}>`
        ).join(`
`),
        o
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    o.length && i.push(`
`, ...He(o)), console.warn(...i);
  }
  ct = !1;
}
function je() {
  let e = V[V.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const s = e.component && e.component.parent;
    e = s && s.vnode;
  }
  return t;
}
function He(e) {
  const t = [];
  return e.forEach((n, s) => {
    t.push(...s === 0 ? [] : [`
`], ...Ie(n));
  }), t;
}
function Ie({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", s = e.component ? e.component.parent == null : !1, o = ` at <${ie(
    e.component,
    e.type,
    s
  )}`, i = ">" + n;
  return e.props ? [o, ...We(e.props), i] : [o + i];
}
function We(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((s) => {
    t.push(...Wt(s, e[s]));
  }), n.length > 3 && t.push(" ..."), t;
}
function Wt(e, t, n) {
  return D(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : x(t) ? (t = Wt(e, d(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : F(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = d(t), n ? t : [`${e}=`, t]);
}
const Bt = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function xt(e, t, n, s) {
  try {
    return s ? e(...s) : e();
  } catch (o) {
    Yt(o, t, n);
  }
}
function Yt(e, t, n, s = !0) {
  const o = t ? t.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: r } = t && t.appContext.config || gt;
  if (t) {
    let a = t.parent;
    const l = t.proxy, u = process.env.NODE_ENV !== "production" ? Bt[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; a; ) {
      const g = a.ec;
      if (g) {
        for (let c = 0; c < g.length; c++)
          if (g[c](e, l, u) === !1)
            return;
      }
      a = a.parent;
    }
    if (i) {
      xt(i, null, 10, [
        e,
        l,
        u
      ]);
      return;
    }
  }
  Be(e, n, o, s, r);
}
function Be(e, t, n, s = !0, o = !1) {
  if (process.env.NODE_ENV !== "production") {
    const i = Bt[t];
    if (n && Ke(n), U(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Ue(), s)
      throw e;
    console.error(e);
  } else {
    if (o)
      throw e;
    console.error(e);
  }
}
const _ = [];
let $ = -1;
const z = [];
let N = null, M = 0;
const Ye = /* @__PURE__ */ Promise.resolve();
let mt = null;
const qe = 100;
function Je(e) {
  let t = $ + 1, n = _.length;
  for (; t < n; ) {
    const s = t + n >>> 1, o = _[s], i = Y(o);
    i < e || i === e && o.flags & 2 ? t = s + 1 : n = s;
  }
  return t;
}
function Ge(e) {
  if (!(e.flags & 1)) {
    const t = Y(e), n = _[_.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= Y(n) ? _.push(e) : _.splice(Je(t), 0, e), e.flags |= 1, qt();
  }
}
function qt() {
  mt || (mt = Ye.then(Jt));
}
function Qe(e) {
  m(e) ? z.push(...e) : N && e.id === -1 ? N.splice(M + 1, 0, e) : e.flags & 1 || (z.push(e), e.flags |= 1), qt();
}
function Xe(e) {
  if (z.length) {
    const t = [...new Set(z)].sort(
      (n, s) => Y(n) - Y(s)
    );
    if (z.length = 0, N) {
      N.push(...t);
      return;
    }
    for (N = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), M = 0; M < N.length; M++) {
      const n = N[M];
      process.env.NODE_ENV !== "production" && Gt(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    N = null, M = 0;
  }
}
const Y = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Jt(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => Gt(e, n) : Ft;
  try {
    for ($ = 0; $ < _.length; $++) {
      const n = _[$];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), xt(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; $ < _.length; $++) {
      const n = _[$];
      n && (n.flags &= -2);
    }
    $ = -1, _.length = 0, Xe(e), mt = null, (_.length || z.length) && Jt(e);
  }
}
function Gt(e, t) {
  const n = e.get(t) || 0;
  if (n > qe) {
    const s = t.i, o = s && se(s.type);
    return Yt(
      `Maximum recursive updates exceeded${o ? ` in component <${o}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
const ut = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (st().__VUE_HMR_RUNTIME__ = {
  createRecord: ft(Ze),
  rerender: ft(tn),
  reload: ft(en)
});
const tt = /* @__PURE__ */ new Map();
function Ze(e, t) {
  return tt.has(e) ? !1 : (tt.set(e, {
    initialDef: et(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function et(e) {
  return re(e) ? e.__vccOpts : e;
}
function tn(e, t) {
  const n = tt.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((s) => {
    t && (s.render = t, et(s.type).render = t), s.renderCache = [], s.job.flags & 8 || s.update();
  }));
}
function en(e, t) {
  const n = tt.get(e);
  if (!n) return;
  t = et(t), kt(n.initialDef, t);
  const s = [...n.instances];
  for (let o = 0; o < s.length; o++) {
    const i = s[o], r = et(i.type);
    let a = ut.get(r);
    a || (r !== n.initialDef && kt(r, t), ut.set(r, a = /* @__PURE__ */ new Set())), a.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (a.add(i), i.ceReload(t.styles), a.delete(i)) : i.parent ? Ge(() => {
      i.job.flags & 8 || (i.parent.update(), a.delete(i));
    }) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(r);
  }
  Qe(() => {
    ut.clear();
  });
}
function kt(e, t) {
  j(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function ft(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (s) {
      console.error(s), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let L, Q = [];
function Qt(e, t) {
  var n, s;
  L = e, L ? (L.enabled = !0, Q.forEach(({ event: o, args: i }) => L.emit(o, ...i)), Q = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((s = (n = window.navigator) == null ? void 0 : n.userAgent) != null && s.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
    Qt(i, t);
  }), setTimeout(() => {
    L || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Q = []);
  }, 3e3)) : Q = [];
}
let nt = null, nn = null;
const on = (e) => e.__isTeleport;
function Xt(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, Xt(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
st().requestIdleCallback;
st().cancelIdleCallback;
const sn = /* @__PURE__ */ Symbol.for("v-ndc"), rn = {};
process.env.NODE_ENV !== "production" && (rn.ownKeys = (e) => (U(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
const an = {}, Zt = (e) => Object.getPrototypeOf(e) === an, ln = (e) => e.__isSuspense, te = /* @__PURE__ */ Symbol.for("v-fgt"), cn = /* @__PURE__ */ Symbol.for("v-txt"), un = /* @__PURE__ */ Symbol.for("v-cmt");
function fn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
const gn = (...e) => ne(
  ...e
), ee = ({ key: e }) => e ?? null, X = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? D(e) || x(e) || F(e) ? { i: nt, r: e, k: t, f: !!n } : e : null);
function dn(e, t = null, n = null, s = 0, o = null, i = e === te ? 0 : 1, r = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && ee(t),
    ref: t && X(t),
    scopeId: nn,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: s,
    dynamicProps: o,
    dynamicChildren: null,
    appContext: null,
    ctx: nt
  };
  return a ? (Dt(l, n), i & 128 && e.normalize(l)) : n && (l.shapeFlag |= D(n) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && U("VNode created with invalid key (NaN). VNode type:", l.type), l;
}
const pn = process.env.NODE_ENV !== "production" ? gn : ne;
function ne(e, t = null, n = null, s = 0, o = null, i = !1) {
  if ((!e || e === sn) && (process.env.NODE_ENV !== "production" && !e && U(`Invalid vnode type when creating vnode: ${e}.`), e = un), fn(e)) {
    const a = ot(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && Dt(a, n), a.patchFlag = -2, a;
  }
  if (re(e) && (e = e.__vccOpts), t) {
    t = hn(t);
    let { class: a, style: l } = t;
    a && !D(a) && (t.class = Pt(a)), P(l) && (Z(l) && !m(l) && (l = j({}, l)), t.style = _t(l));
  }
  const r = D(e) ? 1 : ln(e) ? 128 : on(e) ? 64 : P(e) ? 4 : F(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && r & 4 && Z(e) && (e = d(e), U(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), dn(
    e,
    t,
    n,
    s,
    o,
    r,
    i,
    !0
  );
}
function hn(e) {
  return e ? Z(e) || Zt(e) ? j({}, e) : e : null;
}
function ot(e, t, n = !1, s = !1) {
  const { props: o, ref: i, patchFlag: r, children: a, transition: l } = e, u = t ? yn(o || {}, t) : o, g = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: u,
    key: u && ee(u),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && i ? m(i) ? i.concat(X(t)) : [i, X(t)] : X(t)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && r === -1 && m(a) ? a.map(oe) : a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== te ? r === -1 ? 16 : r | 16 : r,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && ot(e.ssContent),
    ssFallback: e.ssFallback && ot(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && s && Xt(
    g,
    l.clone(g)
  ), g;
}
function oe(e) {
  const t = ot(e);
  return m(e.children) && (t.children = e.children.map(oe)), t;
}
function mn(e = " ", t = 0) {
  return pn(cn, null, e, t);
}
function Dt(e, t) {
  let n = 0;
  const { shapeFlag: s } = e;
  if (t == null)
    t = null;
  else if (m(t))
    n = 16;
  else if (typeof t == "object")
    if (s & 65) {
      const o = t.default;
      o && (o._c && (o._d = !1), Dt(e, o()), o._c && (o._d = !0));
      return;
    } else
      n = 32, !t._ && !Zt(t) && (t._ctx = nt);
  else F(t) ? (t = { default: t, _ctx: nt }, n = 32) : (t = String(t), s & 64 ? (n = 16, t = [mn(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function yn(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    for (const o in s)
      if (o === "class")
        t.class !== s.class && (t.class = Pt([t.class, s.class]));
      else if (o === "style")
        t.style = _t([t.style, s.style]);
      else if (ue(o)) {
        const i = t[o], r = s[o];
        r && i !== r && !(m(i) && i.includes(r)) && (t[o] = i ? [].concat(i, r) : r);
      } else o !== "" && (t[o] = s[o]);
  }
  return t;
}
{
  const e = st(), t = (n, s) => {
    let o;
    return (o = e[n]) || (o = e[n] = []), o.push(s), (i) => {
      o.length > 1 ? o.forEach((r) => r(i)) : o[0](i);
    };
  };
  t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => n
  ), t(
    "__VUE_SSR_SETTERS__",
    (n) => n
  );
}
process.env.NODE_ENV;
const wn = /(?:^|[-_])\w/g, _n = (e) => e.replace(wn, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function se(e, t = !0) {
  return F(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function ie(e, t, n = !1) {
  let s = se(t);
  if (!s && t.__file) {
    const o = t.__file.match(/([^/\\]+)\.\w+$/);
    o && (s = o[1]);
  }
  if (!s && e) {
    const o = (i) => {
      for (const r in i)
        if (i[r] === t)
          return r;
    };
    s = o(e.components) || e.parent && o(
      e.parent.type.components
    ) || o(e.appContext.components);
  }
  return s ? _n(s) : n ? "App" : "Anonymous";
}
function re(e) {
  return F(e) && "__vccOpts" in e;
}
function Pn() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, s = { style: "color:#eb2f96" }, o = {
    __vue_custom_formatter: !0,
    header(c) {
      if (!P(c))
        return null;
      if (c.__isVue)
        return ["div", e, "VueInstance"];
      if (x(c)) {
        const f = c.value;
        return [
          "div",
          {},
          ["span", e, g(c)],
          "<",
          a(f),
          ">"
        ];
      } else {
        if ($t(c))
          return [
            "div",
            {},
            ["span", e, S(c) ? "ShallowReactive" : "Reactive"],
            "<",
            a(c),
            `>${b(c) ? " (readonly)" : ""}`
          ];
        if (b(c))
          return [
            "div",
            {},
            ["span", e, S(c) ? "ShallowReadonly" : "Readonly"],
            "<",
            a(c),
            ">"
          ];
      }
      return null;
    },
    hasBody(c) {
      return c && c.__isVue;
    },
    body(c) {
      if (c && c.__isVue)
        return [
          "div",
          {},
          ...i(c.$)
        ];
    }
  };
  function i(c) {
    const f = [];
    c.type.props && c.props && f.push(r("props", d(c.props))), c.setupState !== gt && f.push(r("setup", c.setupState)), c.data !== gt && f.push(r("data", d(c.data)));
    const w = l(c, "computed");
    w && f.push(r("computed", w));
    const v = l(c, "inject");
    return v && f.push(r("injected", v)), f.push([
      "div",
      {},
      [
        "span",
        {
          style: s.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: c }]
    ]), f;
  }
  function r(c, f) {
    return f = j({}, f), Object.keys(f).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        c
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(f).map((w) => [
          "div",
          {},
          ["span", s, w + ": "],
          a(f[w], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(c, f = !0) {
    return typeof c == "number" ? ["span", t, c] : typeof c == "string" ? ["span", n, JSON.stringify(c)] : typeof c == "boolean" ? ["span", s, c] : P(c) ? ["object", { object: f ? d(c) : c }] : ["span", n, String(c)];
  }
  function l(c, f) {
    const w = c.type;
    if (F(w))
      return;
    const v = {};
    for (const H in c.ctx)
      u(w, H, f) && (v[H] = c.ctx[H]);
    return v;
  }
  function u(c, f, w) {
    const v = c[w];
    if (m(v) && v.includes(f) || P(v) && f in v || c.extends && u(c.extends, f, w) || c.mixins && c.mixins.some((H) => u(H, f, w)))
      return !0;
  }
  function g(c) {
    return S(c) ? "ShallowRef" : c.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(o) : window.devtoolsFormatters = [o];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function Sn() {
  Pn();
}
process.env.NODE_ENV !== "production" && Sn();
var y = /* @__PURE__ */ ((e) => (e.INSTALLED = "installed", e.ENABLED = "enabled", e.DISABLED = "disabled", e.ERROR = "error", e))(y || {}), k = /* @__PURE__ */ ((e) => (e.BOOLEAN = "boolean", e.NUMBER = "number", e.STRING = "string", e.ARRAY = "array", e.OBJECT = "object", e.ENUM = "enum", e))(k || {}), ae = /* @__PURE__ */ ((e) => (e.CHROME = "chrome", e.LOCAL = "local", e.SESSION = "session", e.MEMORY = "memory", e))(ae || {});
class vn {
  data = /* @__PURE__ */ new Map();
  async get(t, n) {
    return this.data.get(t) ?? n;
  }
  async set(t, n) {
    this.data.set(t, n);
  }
  async delete(t) {
    this.data.delete(t);
  }
  async clear() {
    this.data.clear();
  }
  async getAllKeys() {
    return Array.from(this.data.keys());
  }
}
class h {
  storage;
  prefix;
  constructor(t, n = "") {
    this.storage = t, this.prefix = n;
  }
  async get(t, n) {
    const s = this.prefix + t;
    try {
      const o = this.storage.getItem(s);
      return o !== null ? JSON.parse(o) : n;
    } catch (o) {
      return console.error(`Failed to get storage item ${s}:`, o), n;
    }
  }
  async set(t, n) {
    const s = this.prefix + t;
    try {
      this.storage.setItem(s, JSON.stringify(n));
    } catch (o) {
      console.error(`Failed to set storage item ${s}:`, o);
    }
  }
  async delete(t) {
    const n = this.prefix + t;
    try {
      this.storage.removeItem(n);
    } catch (s) {
      console.error(`Failed to delete storage item ${n}:`, s);
    }
  }
  async clear() {
    try {
      if (this.prefix) {
        const t = [];
        for (let n = 0; n < this.storage.length; n++) {
          const s = this.storage.key(n);
          s && s.startsWith(this.prefix) && t.push(s);
        }
        for (const n of t)
          this.storage.removeItem(n);
      } else
        this.storage.clear();
    } catch (t) {
      console.error("Failed to clear storage:", t);
    }
  }
  async getAllKeys() {
    try {
      const t = [];
      for (let n = 0; n < this.storage.length; n++) {
        const s = this.storage.key(n);
        s && s.startsWith(this.prefix) && t.push(s.slice(this.prefix.length));
      }
      return t;
    } catch (t) {
      return console.error("Failed to get all keys:", t), [];
    }
  }
}
class bn {
  prefix;
  fallbackAdapter = null;
  constructor(t = "") {
    this.prefix = t, (typeof window > "u" || !window.chrome?.storage?.local) && (console.warn("Chrome storage not available, falling back to localStorage"), this.fallbackAdapter = new h(localStorage, t));
  }
  async get(t, n) {
    const s = this.prefix + t;
    if (this.fallbackAdapter)
      return this.fallbackAdapter.get(t, n);
    try {
      if (typeof window > "u" || !window.chrome?.storage?.local)
        return console.warn("Chrome storage not available at runtime, falling back to localStorage"), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.get(t, n);
      const o = await chrome.storage.local.get(s);
      return o[s] !== void 0 ? o[s] : n;
    } catch (o) {
      return console.error(`Failed to get chrome storage item ${s}, falling back to localStorage:`, o), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.get(t, n);
    }
  }
  async set(t, n) {
    const s = this.prefix + t;
    if (this.fallbackAdapter)
      return this.fallbackAdapter.set(t, n);
    try {
      if (typeof window > "u" || !window.chrome?.storage?.local)
        return console.warn("Chrome storage not available at runtime, falling back to localStorage"), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.set(t, n);
      await chrome.storage.local.set({
        [s]: n
      });
    } catch (o) {
      return console.error(`Failed to set chrome storage item ${s}, falling back to localStorage:`, o), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.set(t, n);
    }
  }
  async delete(t) {
    const n = this.prefix + t;
    if (this.fallbackAdapter)
      return this.fallbackAdapter.delete(t);
    try {
      if (typeof window > "u" || !window.chrome?.storage?.local)
        return console.warn("Chrome storage not available at runtime, falling back to localStorage"), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.delete(t);
      await chrome.storage.local.remove(n);
    } catch (s) {
      return console.error(`Failed to delete chrome storage item ${n}, falling back to localStorage:`, s), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.delete(t);
    }
  }
  async clear() {
    if (this.fallbackAdapter)
      return this.fallbackAdapter.clear();
    try {
      if (typeof window > "u" || !window.chrome?.storage?.local)
        return console.warn("Chrome storage not available at runtime, falling back to localStorage"), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.clear();
      const t = await chrome.storage.local.get(null), n = Object.keys(t).filter(
        (s) => s.startsWith(this.prefix)
      );
      n.length > 0 && await chrome.storage.local.remove(n);
    } catch (t) {
      return console.error("Failed to clear chrome storage, falling back to localStorage:", t), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.clear();
    }
  }
  async getAllKeys() {
    if (this.fallbackAdapter)
      return this.fallbackAdapter.getAllKeys();
    try {
      if (typeof window > "u" || !window.chrome?.storage?.local)
        return console.warn("Chrome storage not available at runtime, falling back to localStorage"), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.getAllKeys();
      const t = await chrome.storage.local.get(null);
      return Object.keys(t).filter((n) => n.startsWith(this.prefix)).map((n) => n.slice(this.prefix.length));
    } catch (t) {
      return console.error("Failed to get all chrome storage keys, falling back to localStorage:", t), this.fallbackAdapter = new h(localStorage, this.prefix), this.fallbackAdapter.getAllKeys();
    }
  }
}
function En(e) {
  const { type: t, prefix: n = "" } = e, s = typeof window < "u" && window.chrome?.storage?.local;
  switch (t) {
    case "chrome":
      return s ? new bn(n) : (console.warn("Chrome storage requested but not available, using localStorage instead"), new h(localStorage, n));
    case "local":
      return new h(localStorage, n);
    case "session":
      return new h(sessionStorage, n);
    default:
      return new vn();
  }
}
class $n {
  plugins = /* @__PURE__ */ new Map();
  pluginContexts = /* @__PURE__ */ new Map();
  pluginStatuses = /* @__PURE__ */ new Map();
  pluginConfigs = /* @__PURE__ */ new Map();
  eventHandlers = /* @__PURE__ */ new Map();
  extensions = /* @__PURE__ */ new Map();
  extendedPlatforms = Me([]);
  storageAdapter;
  storageOptions;
  saveTimer = null;
  // 响应式数据
  pluginsData = Et({
    plugins: [],
    settings: {
      autoUpdate: !0,
      pluginDir: "plugins",
      storageType: "chrome",
      storagePrefix: "plugin-manager-"
    }
  });
  constructor(t = {}) {
    this.storageOptions = {
      type: "local",
      prefix: "plugin-manager-",
      autoSave: !0,
      autoSaveInterval: 5e3,
      ...t
    }, this.pluginsData.settings.storageType = this.storageOptions.type;
  }
  // 插件API实现
  pluginApi = {
    registerPlatform: (t) => {
      this.extendedPlatforms.value.push(t), this.emit("platformRegistered", t);
    },
    unregisterPlatform: (t) => {
      this.extendedPlatforms.value = this.extendedPlatforms.value.filter(
        (n) => n.name !== t
      ), this.emit("platformUnregistered", t);
    },
    getPlatforms: () => [...this.extendedPlatforms.value],
    on: (t, n) => {
      this.eventHandlers.has(t) || this.eventHandlers.set(t, []), this.eventHandlers.get(t)?.push(n);
    },
    emit: (t, ...n) => {
      this.emit(t, ...n);
    },
    off: (t, n) => {
      const s = this.eventHandlers.get(t);
      s && this.eventHandlers.set(
        t,
        s.filter((o) => o !== n)
      );
    },
    addExtension: (t, n) => {
      this.extensions.has(t) || this.extensions.set(t, []), this.extensions.get(t)?.push(n);
    },
    getExtensions: (t) => this.extensions.get(t) || []
  };
  /**
   * 注册事件监听器
   */
  on(t, n) {
    this.eventHandlers.has(t) || this.eventHandlers.set(t, []), this.eventHandlers.get(t)?.push(n);
  }
  /**
   * 触发事件
   */
  emit(t, ...n) {
    const s = this.eventHandlers.get(t);
    s && s.forEach((o) => {
      try {
        o(...n);
      } catch (i) {
        console.error(`Error in event handler for ${t}:`, i);
      }
    });
  }
  /**
   * 合并插件默认配置
   * @param plugin 插件对象
   * @param existingConfig 现有配置
   */
  mergeDefaultConfig(t, n = {}) {
    if (!t.configDefinition)
      return n;
    const s = { ...n };
    for (const o of t.configDefinition.items)
      s[o.key] === void 0 && (s[o.key] = o.defaultValue);
    return s;
  }
  /**
   * 验证插件配置
   * @param plugin 插件对象
   * @param config 配置对象
   */
  validatePluginConfig(t, n) {
    const s = {
      isValid: !0,
      errors: []
    };
    if (!t.configDefinition)
      return s;
    for (const o of t.configDefinition.items) {
      const i = n[o.key];
      if (o.required && i === void 0) {
        s.isValid = !1, s.errors.push({
          key: o.key,
          message: `${o.name} is required`
        });
        continue;
      }
      if (i !== void 0) {
        const r = o.type, a = Array.isArray(i) ? "array" : typeof i;
        if (r !== a && !(r === k.ENUM && a !== "undefined")) {
          s.isValid = !1, s.errors.push({
            key: o.key,
            message: `${o.name} must be of type ${r}`
          });
          continue;
        }
        if (r === k.NUMBER && (o.min !== void 0 && i < o.min && (s.isValid = !1, s.errors.push({
          key: o.key,
          message: `${o.name} must be greater than or equal to ${o.min}`
        })), o.max !== void 0 && i > o.max && (s.isValid = !1, s.errors.push({
          key: o.key,
          message: `${o.name} must be less than or equal to ${o.max}`
        }))), r === k.STRING || r === k.ARRAY) {
          const l = (r === k.STRING, i.length);
          o.minLength !== void 0 && l < o.minLength && (s.isValid = !1, s.errors.push({
            key: o.key,
            message: `${o.name} must be at least ${o.minLength} characters long`
          })), o.maxLength !== void 0 && l > o.maxLength && (s.isValid = !1, s.errors.push({
            key: o.key,
            message: `${o.name} must be at most ${o.maxLength} characters long`
          }));
        }
        if (r === k.ENUM && o.enumOptions) {
          const l = o.enumOptions.map((u) => u.value);
          l.includes(i) || (s.isValid = !1, s.errors.push({
            key: o.key,
            message: `${o.name} must be one of: ${l.join(", ")}`
          }));
        }
        if (o.validation) {
          let l = !0, u = "";
          if (typeof o.validation == "string")
            l = new RegExp(o.validation).test(i), l || (u = `${o.name} is invalid`);
          else if (typeof o.validation == "function") {
            const g = o.validation(i);
            typeof g == "string" ? (l = !1, u = g) : (l = g, l || (u = `${o.name} is invalid`));
          }
          l || (s.isValid = !1, s.errors.push({
            key: o.key,
            message: u
          }));
        }
      }
    }
    return s;
  }
  /**
   * 加载插件
   */
  async loadPlugin(t) {
    const n = t.metadata.id;
    if (this.plugins.has(n)) {
      console.warn(`Plugin ${n} is already loaded`);
      return;
    }
    try {
      const s = y.INSTALLED, o = this.pluginConfigs.get(n) || {}, i = this.mergeDefaultConfig(t, o), r = {
        metadata: t.metadata,
        status: s,
        config: i,
        storage: {
          get: async (l, u) => this.getPluginStorage(n, l, u),
          set: async (l, u) => {
            await this.setPluginStorage(n, l, u);
          },
          delete: async (l) => {
            await this.deletePluginStorage(n, l);
          },
          clear: async () => {
            await this.clearPluginStorage(n);
          }
        }
      };
      this.plugins.set(n, t), this.pluginContexts.set(n, r), this.pluginStatuses.set(n, s), this.pluginConfigs.set(n, i);
      const a = {
        id: n,
        metadata: t.metadata,
        status: s,
        config: i
      };
      this.pluginsData.plugins.push(a), console.log(
        `Plugin ${n} added to pluginsData.plugins. Current plugins count: ${this.pluginsData.plugins.length}`
      ), console.log("Plugin data added:", a), console.log("Current pluginsData.plugins:", this.pluginsData.plugins), console.log(
        `Plugin ${n} loaded successfully with status ${s}`
      );
    } catch (s) {
      throw console.error(`Failed to load plugin ${n}:`, s), s;
    }
  }
  /**
   * 激活插件
   */
  async activatePlugin(t) {
    const n = this.plugins.get(t);
    if (!n)
      throw new Error(`Plugin ${t} not found`);
    const s = this.pluginContexts.get(t);
    if (!s)
      throw new Error(`Plugin context for ${t} not found`);
    try {
      s.status = y.ENABLED, this.pluginStatuses.set(t, y.ENABLED);
      const o = this.pluginsData.plugins.find(
        (i) => i.id === t
      );
      o && (o.status = y.ENABLED), await n.activate(s, this.pluginApi), this.emit("pluginActivated", t), console.log(`Plugin ${t} activated successfully`);
    } catch (o) {
      console.error(`Failed to activate plugin ${t}:`, o), s.status = y.ERROR, this.pluginStatuses.set(t, y.ERROR);
      const i = this.pluginsData.plugins.find(
        (r) => r.id === t
      );
      throw i && (i.status = y.ERROR), o;
    }
  }
  /**
   * 停用插件
   */
  async deactivatePlugin(t) {
    const n = this.plugins.get(t);
    if (!n)
      throw new Error(`Plugin ${t} not found`);
    const s = this.pluginContexts.get(t);
    if (!s)
      throw new Error(`Plugin context for ${t} not found`);
    try {
      await n.deactivate(s, this.pluginApi), s.status = y.DISABLED, this.pluginStatuses.set(t, y.DISABLED);
      const o = this.pluginsData.plugins.find(
        (i) => i.id === t
      );
      o && (o.status = y.DISABLED), this.emit("pluginDeactivated", t), console.log(`Plugin ${t} deactivated successfully`);
    } catch (o) {
      throw console.error(`Failed to deactivate plugin ${t}:`, o), o;
    }
  }
  /**
   * 卸载插件
   */
  async uninstallPlugin(t) {
    if (!this.plugins.get(t))
      throw new Error(`Plugin ${t} not found`);
    this.pluginStatuses.get(t) === y.ENABLED && await this.deactivatePlugin(t), this.plugins.delete(t), this.pluginContexts.delete(t), this.pluginStatuses.delete(t), this.pluginConfigs.delete(t), this.pluginsData.plugins = this.pluginsData.plugins.filter(
      (s) => s.id !== t
    ), await this.clearPluginStorage(t), this.emit("pluginUninstalled", t), console.log(`Plugin ${t} uninstalled successfully`);
  }
  /**
   * 获取所有插件
   */
  getPlugins() {
    return Array.from(this.plugins.entries());
  }
  /**
   * 获取插件状态
   */
  getPluginStatus(t) {
    const n = this.pluginsData.plugins.find((s) => s.id === t);
    return n ? n.status : this.pluginStatuses.get(t);
  }
  /**
   * 获取插件配置
   */
  getPluginConfig(t) {
    return this.pluginConfigs.get(t);
  }
  /**
   * 更新插件配置
   */
  async updatePluginConfig(t, n) {
    const s = this.plugins.get(t);
    if (!s)
      throw new Error(`Plugin ${t} not found`);
    const i = { ...this.pluginConfigs.get(t) || {}, ...n }, r = this.validatePluginConfig(s, i);
    if (!r.isValid)
      return console.error(`Plugin ${t} configuration validation failed:`, r.errors), r;
    const a = this.mergeDefaultConfig(s, i);
    this.pluginConfigs.set(t, a);
    const l = this.pluginContexts.get(t);
    l && (l.config = a);
    const u = this.pluginsData.plugins.find((g) => g.id === t);
    return u && (u.config = a), await this.savePluginConfig(t, a), this.emit("pluginConfigUpdated", t, a), console.log(`Plugin ${t} configuration updated successfully`), r;
  }
  /**
   * 获取插件配置定义
   */
  getPluginConfigDefinition(t) {
    return this.plugins.get(t)?.configDefinition;
  }
  /**
   * 重置插件配置到默认值
   */
  async resetPluginConfig(t) {
    const n = this.plugins.get(t);
    if (!n)
      throw new Error(`Plugin ${t} not found`);
    const s = this.mergeDefaultConfig(n, {});
    await this.updatePluginConfig(t, s), console.log(`Plugin ${t} configuration reset to default values`);
  }
  /**
   * 获取当前语言环境
   */
  getCurrentLocale() {
    return le();
  }
  /**
   * 获取插件的本地化名称
   */
  getPluginLocalizedName(t) {
    const n = this.getCurrentLocale(), s = "metadata" in t ? t.metadata : t;
    if (s.localized && s.localized[n])
      return s.localized[n].name;
    const o = n.split("-")[0];
    return s.localized && s.localized[o] ? s.localized[o].name : s.name;
  }
  /**
   * 获取插件的本地化描述
   */
  getPluginLocalizedDescription(t) {
    const n = this.getCurrentLocale(), s = "metadata" in t ? t.metadata : t;
    if (s.localized && s.localized[n])
      return s.localized[n].description;
    const o = n.split("-")[0];
    return s.localized && s.localized[o] ? s.localized[o].description : s.description;
  }
  /**
   * 获取搜索平台的本地化名称
   */
  getPlatformLocalizedName(t) {
    const n = this.getCurrentLocale();
    if (t.localized && t.localized[n])
      return t.localized[n].name;
    const s = n.split("-")[0];
    return t.localized && t.localized[s] ? t.localized[s].name : t.name;
  }
  /**
   * 获取搜索平台的本地化描述
   */
  getPlatformLocalizedDescription(t) {
    const n = this.getCurrentLocale();
    if (t.localized && t.localized[n])
      return t.localized[n].description;
    const s = n.split("-")[0];
    return t.localized && t.localized[s] ? t.localized[s].description : t.description;
  }
  /**
   * 获取所有扩展的平台（包括内置和插件添加的）
   */
  async getAllPlatforms() {
    const { allPlatforms: t } = await import("@gitcoffee/search");
    return [...t, ...this.extendedPlatforms.value];
  }
  /**
   * 保存插件存储
   */
  async savePluginStorage() {
    try {
      const t = await C.get("appSettings"), n = typeof t == "object" && t !== null ? t : {};
      await C.set("appSettings", {
        ...n,
        pluginManagerData: this.pluginsData
      }), console.log("Plugin storage saved to storage");
    } catch (t) {
      console.error("Failed to save plugin storage:", t);
    }
  }
  /**
   * 获取插件存储数据
   */
  async getPluginStorage(t, n, s) {
    try {
      const o = `plugin_${t}_${n}`;
      return await C.get(o, s);
    } catch (o) {
      return console.error(
        `Failed to get plugin storage for ${t}:${n}:`,
        o
      ), s;
    }
  }
  /**
   * 设置插件存储数据
   */
  async setPluginStorage(t, n, s) {
    try {
      const o = `plugin_${t}_${n}`;
      await C.set(o, s);
    } catch (o) {
      console.error(
        `Failed to set plugin storage for ${t}:${n}:`,
        o
      );
    }
  }
  /**
   * 删除插件存储数据
   */
  async deletePluginStorage(t, n) {
    try {
      const s = `plugin_${t}_${n}`;
      await C.remove(s);
    } catch (s) {
      console.error(
        `Failed to delete plugin storage for ${t}:${n}:`,
        s
      );
    }
  }
  /**
   * 清除插件存储
   */
  async clearPluginStorage(t) {
    try {
      const s = (await this.storageAdapter.getAllKeys()).filter(
        (o) => o.startsWith(`plugin_${t}_`)
      );
      for (const o of s)
        await this.storageAdapter.delete(o);
    } catch (n) {
      console.error(`Failed to clear plugin storage for ${t}:`, n);
    }
  }
  /**
   * 更新存储前缀
   * @param prefix 新的存储前缀
   */
  async updateStoragePrefix(t) {
    console.log(`Updating storage prefix to ${t}`), await this.updateStorageAdapter(this.storageOptions.type, t);
  }
  /**
   * 保存插件配置
   */
  async savePluginConfig(t, n) {
    try {
      const s = `plugin_config_${t}`;
      await this.storageAdapter.set(s, n);
    } catch (s) {
      console.error(`Failed to save plugin config for ${t}:`, s);
    }
  }
  /**
   * 初始化插件管理器
   */
  async init() {
    this.storageOptions.autoSave && (this.saveTimer = setInterval(async () => {
      await this.savePluginStorage();
    }, this.storageOptions.autoSaveInterval || 5e3), console.log(`Auto-save enabled with interval ${this.storageOptions.autoSaveInterval || 5e3}ms`)), this.on("pluginConfigUpdated", async () => {
      await this.savePluginStorage();
    }), this.on("pluginActivated", async () => {
      await this.savePluginStorage();
    }), this.on("pluginDeactivated", async () => {
      await this.savePluginStorage();
    }), this.on("storageTypeChanged", async (t, n) => {
      await this.updateStorageAdapter(t, n), await this.savePluginStorage();
    }), console.log("Plugin Manager initialized successfully"), console.log(`Using storage type: ${this.storageOptions.type}, prefix: ${this.storageOptions.prefix}`);
  }
  /**
   * 更新存储适配器
   * @param type 新的存储类型
   * @param prefix 新的存储前缀
   */
  async updateStorageAdapter(t, n) {
    console.log(`Updating storage adapter to ${t} with prefix ${n}`), this.pluginsData, this.storageOptions.type = t, this.storageOptions.prefix = n, this.storageAdapter = En(this.storageOptions), this.pluginsData.settings.storageType = t, this.pluginsData.settings.storagePrefix = n, await this.savePluginStorage(), console.log("Storage adapter updated successfully");
  }
  /**
   * 加载插件存储数据
   */
  async loadPluginStorage() {
    try {
      let t = null;
      const n = await C.get("appSettings");
      if (n && n.pluginManagerData ? (t = n.pluginManagerData, console.log(
        "Plugin storage loaded from unified appSettings:",
        t
      )) : (t = await C.get("pluginManagerData"), console.log(
        "Plugin storage loaded from independent key:",
        t
      )), t) {
        let s = t.plugins;
        if (Array.isArray(s) || (s = []), console.log(
          `Found ${this.pluginsData.plugins.length} plugins before loading storage, processing ${s.length} saved plugins`
        ), s.forEach((o) => {
          const i = this.pluginsData.plugins.findIndex(
            (r) => r.id === o.id
          );
          if (i !== -1) {
            console.log(
              `Updating existing plugin ${o.id} from storage`
            );
            const r = this.pluginsData.plugins[i];
            this.pluginsData.plugins[i] = {
              ...r,
              status: o.status,
              config: o.config
            }, this.pluginStatuses.set(o.id, o.status);
            const a = this.pluginContexts.get(o.id);
            a && (a.status = o.status, a.config = o.config);
          } else
            console.warn(
              `Found plugin ${o.id} in storage but not loaded, skipping`
            );
        }), t.settings && (this.pluginsData.settings = t.settings, t.settings.storageType && t.settings.storagePrefix)) {
          const o = ae[t.settings.storageType] || this.storageOptions.type;
          await this.updateStorageAdapter(
            o,
            t.settings.storagePrefix
          );
        }
        console.log(
          "Plugin storage loaded successfully, processed",
          s.length,
          "saved plugins"
        );
      }
    } catch (t) {
      console.error("Failed to load plugin storage:", t);
    }
  }
}
const p = new $n();
class xn {
  pluginSources = [];
  loadedPlugins = /* @__PURE__ */ new Set();
  options;
  constructor(t = {}) {
    this.options = {
      allowRemotePlugins: !0,
      enablePluginValidation: !0,
      allowedOrigins: [],
      ...t
    };
  }
  /**
   * 添加插件源
   * @param source 插件源URL或路径
   */
  addPluginSource(t) {
    this.pluginSources.includes(t) || (this.pluginSources.push(t), console.log(`Added plugin source: ${t}`));
  }
  /**
   * 移除插件源
   * @param source 插件源URL或路径
   */
  removePluginSource(t) {
    this.pluginSources = this.pluginSources.filter((n) => n !== t), console.log(`Removed plugin source: ${t}`);
  }
  /**
   * 更新加载器配置
   * @param options 新的配置选项
   */
  updateOptions(t) {
    this.options = { ...this.options, ...t }, console.log("Updated plugin loader options:", this.options);
  }
  /**
   * 获取所有插件源
   */
  getPluginSources() {
    return [...this.pluginSources];
  }
  /**
   * 从URL加载插件
   * @param url 插件URL
   */
  async loadPluginFromUrl(t) {
    try {
      if (this.loadedPlugins.has(t))
        return console.warn(`Plugin from ${t} is already loaded`), null;
      if (!this.options.allowRemotePlugins)
        return console.error("Remote plugin loading is disabled"), null;
      if (this.options.allowedOrigins && this.options.allowedOrigins.length > 0) {
        const i = new URL(t);
        if (!this.options.allowedOrigins.includes(i.origin))
          return console.error(`Origin ${i.origin} is not allowed to load plugins`), null;
      }
      const n = await fetch(t);
      if (!n.ok)
        throw new Error(
          `Failed to fetch plugin from ${t}: ${n.statusText}`
        );
      const s = n.headers.get("Content-Type");
      (!s || !s.includes("application/javascript")) && console.warn(`Plugin from ${t} has unexpected Content-Type: ${s}`), console.warn("Remote plugin loading is currently limited due to security restrictions"), console.warn(`Plugin from ${t} will be loaded in restricted mode`);
      const o = this.createSafeRemotePlugin(t);
      return await p.loadPlugin(o), this.loadedPlugins.add(t), o;
    } catch (n) {
      return console.error(`Failed to load plugin from ${t}:`, n), null;
    }
  }
  /**
   * 从本地文件系统加载插件
   * @param filePath 插件文件路径
   */
  async loadPluginFromFile(t) {
    try {
      if (this.loadedPlugins.has(t))
        return console.warn(`Plugin from ${t} is already loaded`), null;
      const n = this.getPluginUrl(t);
      console.log(`Loading plugin from file: ${t} -> ${n}`);
      const s = await import(n), o = s.default || s;
      if (!this.isValidPlugin(o))
        throw new Error(`Plugin from ${t} is not a valid plugin`);
      return await p.loadPlugin(o), this.loadedPlugins.add(t), console.log(`Plugin loaded successfully from ${t}`), o;
    } catch (n) {
      return console.error(`Failed to load plugin from ${t}:`, n), null;
    }
  }
  /**
   * 从目录加载所有插件
   * @param dirPath 插件目录路径
   */
  async loadPluginsFromDirectory(t) {
    const n = [];
    try {
      if (console.log(`Loading plugins from directory: ${t}`), typeof window > "u")
        return console.warn("Cannot load plugins from directory in non-browser environment"), n;
      if (window.chrome?.runtime?.getPackageDirectoryEntry)
        try {
          const s = await this.getChromePackageDirectoryEntry(), o = await this.getDirectoryEntry(s, t), r = (await this.readDirectoryEntries(o)).filter((u) => u.isFile && (u.name.endsWith(".js") || u.name.endsWith(".ts"))).map(async (u) => {
            try {
              const c = await import(this.getPluginUrl(`${t}/${u.name}`)), f = c.default || c;
              return this.isValidPlugin(f) ? (await p.loadPlugin(f), this.loadedPlugins.add(u.fullPath), console.log(`Loaded plugin: ${u.name}`), f) : null;
            } catch (g) {
              return console.error(`Failed to load plugin ${u.name}:`, g), null;
            }
          }), l = (await Promise.all(r)).filter((u) => u !== null);
          n.push(...l);
        } catch (s) {
          console.warn(`Directory ${t} not found or inaccessible, skipping plugin loading:`, s);
        }
      else
        console.warn("Chrome API not available, trying alternative plugin loading method");
      return console.log(`Loaded ${n.length} plugins from directory ${t}`), n;
    } catch (s) {
      return console.error(`Failed to load plugins from directory ${t}:`, s), n;
    }
  }
  /**
   * 创建安全的远程插件对象
   * @param url 插件URL
   */
  createSafeRemotePlugin(t) {
    return {
      metadata: {
        id: `remote-plugin-${this.hashCode(t)}`,
        name: `Remote Plugin (${new URL(t).hostname})`,
        version: "1.0.0",
        author: "Unknown",
        description: `Remote plugin loaded from ${t}`,
        license: "Unknown"
      },
      activate: () => (console.warn(`Remote plugin activation is limited for security reasons: ${t}`), Promise.resolve()),
      deactivate: () => (console.warn(`Remote plugin deactivation is limited for security reasons: ${t}`), Promise.resolve())
    };
  }
  /**
   * 字符串哈希函数
   * @param str 输入字符串
   */
  hashCode(t) {
    let n = 0;
    for (let s = 0; s < t.length; s++) {
      const o = t.charCodeAt(s);
      n = (n << 5) - n + o, n = n & n;
    }
    return n;
  }
  /**
   * 获取插件的URL路径
   * @param source 插件来源
   */
  getPluginUrl(t) {
    return t.startsWith("plugins/") ? `../../${t}` : (t.endsWith(".js"), t);
  }
  /**
   * 验证插件是否有效
   * @param plugin 插件对象
   */
  isValidPlugin(t) {
    if (!this.options.enablePluginValidation)
      return !0;
    const n = typeof t == "object" && t !== null && typeof t.metadata == "object" && typeof t.activate == "function" && typeof t.deactivate == "function" && typeof t.metadata.id == "string" && typeof t.metadata.name == "string" && typeof t.metadata.version == "string" && typeof t.metadata.author == "string" && typeof t.metadata.description == "string" && typeof t.metadata.license == "string";
    return n || console.error("Invalid plugin format:", {
      hasMetadata: typeof t?.metadata == "object",
      hasActivate: typeof t?.activate == "function",
      hasDeactivate: typeof t?.deactivate == "function",
      hasValidId: typeof t?.metadata?.id == "string",
      hasValidName: typeof t?.metadata?.name == "string",
      hasValidVersion: typeof t?.metadata?.version == "string",
      hasValidAuthor: typeof t?.metadata?.author == "string",
      hasValidDescription: typeof t?.metadata?.description == "string",
      hasValidLicense: typeof t?.metadata?.license == "string"
    }), n;
  }
  /**
   * 获取Chrome扩展包目录条目
   */
  async getChromePackageDirectoryEntry() {
    return new Promise((t, n) => {
      typeof window < "u" && window.chrome?.runtime?.getPackageDirectoryEntry ? window.chrome.runtime.getPackageDirectoryEntry(
        (s) => {
          t(s);
        }
      ) : n(new Error("Chrome API not available"));
    });
  }
  /**
   * 获取目录条目
   * @param parent 父目录条目
   * @param path 路径
   */
  async getDirectoryEntry(t, n) {
    return new Promise((s, o) => {
      t.getDirectory(n, { create: !1 }, (i) => s(i), o);
    });
  }
  /**
   * 读取目录条目
   * @param dirEntry 目录条目
   */
  async readDirectoryEntries(t) {
    return new Promise((n, s) => {
      const o = [], i = t.createReader(), r = () => {
        i.readEntries((a) => {
          a.length === 0 ? n(o) : (o.push(...a), r());
        }, s);
      };
      r();
    });
  }
  /**
   * 从条目获取文件
   * @param entry 文件条目
   */
  async getFileFromEntry(t) {
    return new Promise((n, s) => {
      t.file(n, s);
    });
  }
  /**
   * 加载所有插件源
   */
  async loadAllPlugins() {
    const t = [];
    console.log("Loading plugins from all sources...");
    const n = this.pluginSources.map(async (o) => o.startsWith("http://") || o.startsWith("https://") ? this.loadPluginFromUrl(o) : o.endsWith(".js") || o.endsWith(".ts") ? this.loadPluginFromFile(o) : this.loadPluginsFromDirectory(o)), s = await Promise.all(n);
    for (const o of s)
      Array.isArray(o) ? t.push(...o) : o && t.push(o);
    return console.log(`Loaded total ${t.length} plugins from all sources`), t;
  }
  /**
   * 清除所有已加载插件
   */
  clearLoadedPlugins() {
    this.loadedPlugins.clear();
  }
}
const Vt = new xn();
async function Nn(e = {}) {
  console.log("Starting plugin system initialization...");
  try {
    e.storagePrefix && (console.log(`Setting plugin storage prefix: ${e.storagePrefix}`), await p.updateStoragePrefix(e.storagePrefix)), console.log("Initializing plugin manager..."), await p.init(), console.log("Plugin manager initialized successfully");
    const t = e.pluginSources || ["plugins"];
    for (const o of t)
      console.log(`Adding plugin source: ${o}`), Vt.addPluginSource(o);
    if (e.plugins && e.plugins.length > 0) {
      console.log(`Loading ${e.plugins.length} custom plugins...`);
      for (const o of e.plugins)
        console.log(`Loading plugin ${o.metadata.id}...`), await p.loadPlugin(o), console.log(`Plugin ${o.metadata.id} loaded successfully`);
    }
    e.loadDefaultPlugins !== !1 && (console.log("Loading default plugins..."), await Dn(), console.log("Default plugins loaded successfully")), console.log("Loading plugins from sources...");
    const n = await Vt.loadAllPlugins();
    if (console.log(`Loaded ${n.length} plugins from sources`), e.autoActivatePlugins !== !1) {
      console.log("Activating enabled plugins...");
      const o = p.getPlugins();
      console.log(`Found ${o.length} total plugins`);
      for (const [i, r] of o) {
        const a = p.getPluginStatus(i);
        console.log(`Plugin ${i} status: ${a}`), a === y.ENABLED && (console.log(`Activating plugin ${i}...`), await p.activatePlugin(i), console.log(`Activated plugin ${i} successfully`));
      }
    }
    console.log("Loading plugin storage data..."), await p.loadPluginStorage(), console.log("Plugin storage loaded successfully"), console.log("Plugin system initialized successfully"), console.log("Final plugins list:", p.pluginsData.plugins);
    const s = await p.getAllPlatforms();
    console.log(
      "Total extended platforms:",
      s.length
    );
  } catch (t) {
    console.error("Failed to initialize plugin system:", t), console.error("Plugin system initialization error details:", t.stack);
  }
}
async function Dn() {
  try {
    const [
      e,
      t,
      n,
      s,
      o,
      i,
      r
    ] = await Promise.all([
      import("./academic-search-plugin-BzsoUyKM.js").then((l) => l.default),
      import("./it-community-plugin-DdCPDnzA.js").then((l) => l.default),
      import("./code-search-plugin-DgDQcaIj.js").then((l) => l.default),
      import("./container-search-plugin-Y5eMc3nT.js").then((l) => l.default),
      import("./dependency-search-plugin-BRl1KpLn.js").then((l) => l.default),
      import("./example-plugin-BASiG4BJ.js").then((l) => l.default),
      import("./social-media-plugin-D7SXZJlX.js").then((l) => l.default)
    ]), a = [
      e,
      t,
      n,
      s,
      o,
      i,
      r
    ];
    for (const l of a)
      console.log(`Loading default plugin ${l.metadata.id}...`), await p.loadPlugin(l), console.log(`Default plugin ${l.metadata.id} loaded successfully`);
  } catch (e) {
    console.warn("Failed to load some default plugins:", e);
  }
}
async function Rn(e) {
  await p.loadPlugin(e);
}
async function Cn(e) {
  await p.activatePlugin(e);
}
async function kn(e) {
  await p.deactivatePlugin(e);
}
async function Vn(e) {
  await p.uninstallPlugin(e);
}
async function Fn(e, t) {
  return p.updatePluginConfig(e, t);
}
function Tn(e) {
  return p.getPluginConfigDefinition(e);
}
async function Mn(e) {
  await p.resetPluginConfig(e);
}
function Ln(e, t) {
  return p.validatePluginConfig(e, t);
}
export {
  y as PluginStatus,
  Cn as activatePlugin,
  kn as deactivatePlugin,
  Tn as getPluginConfigDefinition,
  Nn as initPluginSystem,
  Vt as pluginLoader,
  p as pluginManager,
  Rn as registerPlugin,
  Mn as resetPluginConfig,
  Vn as uninstallPlugin,
  Fn as updatePluginConfig,
  Ln as validatePluginConfig
};
//# sourceMappingURL=index.mjs.map
